import React from 'react';
import { Formik, FieldArray } from 'formik';
import classNames from 'classnames';
import Creatable from 'react-select/creatable';
import { useCreateProjectTagsMutation, useGetConfigQuery } from '../../store';
import { Modal } from '../../components';
import { QuickAlert } from '../../components';

export const NewTagModal = (props) => {
    const { data: config } = useGetConfigQuery();

    const { show, onClose, projectId, tags } = props;

    const [createProjectTags] = useCreateProjectTagsMutation();

    const defaultTagValues = {
        value: '',
        room: '',
        equipmentType: '',
        trade: '',
        quantity: '',
    };

    const handleSubmit = async (values, formikHelpers) => {
        const tagsToSend = (values.tags || []).map((t) => ({
            ...t,
            quantity: parseInt(t.quantity, 10) || 1,
        }));

        createProjectTags({ id: projectId, tags: tagsToSend });
        formikHelpers.setSubmitting(false);
        onClose();
    };

    const handleValidate = () => {
        let errors = {};
        return errors;
    };

    const equipmentList = config?.options.equipmentList ?? [];
    const tradeList = config?.options.tradeList ?? [];

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="sm:container p-4">
                <h1>Tag</h1>
                <div>
                    <Formik
                        initialValues={{ tags: [defaultTagValues] }}
                        validate={handleValidate}
                        onSubmit={handleSubmit}
                    >
                        {(formik) => (
                            <form onSubmit={formik.handleSubmit}>
                                {Object.keys(formik.errors ?? {}).map(
                                    (k) =>
                                        formik.touched?.[k] && (
                                            <QuickAlert
                                                key={k}
                                                kind="error"
                                                msg={formik.errors?.[k]}
                                            />
                                        ),
                                )}

                                <FieldArray name="tags">
                                    {(tagsHelpers) => (
                                        <div className="mb-4">
                                            {formik.values.tags.map(
                                                (row, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="flex justify-between gap-4 mb-2"
                                                    >
                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags[${idx}].value`}
                                                            >
                                                                Tag
                                                            </label>
                                                            <Creatable
                                                                classNames={{
                                                                    control: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'flex items-center w-full min-w-[200px] !bg-black-5  border border-black-10 !hover:border-black-20 !rounded-none !shadow-none',
                                                                            state.isFocused &&
                                                                                '!border-green-dark',
                                                                        ),
                                                                    option: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            state.isSelected &&
                                                                                'bg-green-primary text-white',
                                                                            'hover:bg-green-primary hover:text-white over:text-white',
                                                                        ),
                                                                    menu: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'shadow-swegon2 border border-black-20 !z-50',
                                                                        ),
                                                                    menuPortal:
                                                                        (
                                                                            state,
                                                                        ) =>
                                                                            '!z-50',
                                                                }}
                                                                menuPortalTarget={
                                                                    document.body
                                                                }
                                                                components={{
                                                                    DropdownIndicator:
                                                                        null,
                                                                }}
                                                                hideSelectedOptions
                                                                options={[
                                                                    ...new Set(
                                                                        (
                                                                            tags ||
                                                                            []
                                                                        )
                                                                            .map(
                                                                                (
                                                                                    t,
                                                                                ) =>
                                                                                    t.value,
                                                                            )
                                                                            .filter(
                                                                                Boolean,
                                                                            )
                                                                            .sort(),
                                                                    ),
                                                                ].map(
                                                                    (
                                                                        value,
                                                                    ) => ({
                                                                        value,
                                                                        label: value,
                                                                    }),
                                                                )}
                                                                onChange={(
                                                                    selectedOption,
                                                                ) => {
                                                                    formik.setFieldValue(
                                                                        `tags[${idx}].value`,
                                                                        selectedOption
                                                                            ? selectedOption.value
                                                                            : '',
                                                                    );
                                                                }}
                                                                onBlur={(
                                                                    event,
                                                                ) => {
                                                                    const inputValue =
                                                                        event
                                                                            .target
                                                                            .value;
                                                                    if (
                                                                        inputValue.trim() !==
                                                                        ''
                                                                    ) {
                                                                        formik.setFieldValue(
                                                                            `tags[${idx}].value`,
                                                                            inputValue,
                                                                        );
                                                                    }
                                                                }}
                                                                value={{
                                                                    value: row.value,
                                                                    label: row.value,
                                                                }}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags[${idx}].equipmentType`}
                                                            >
                                                                Equipment Type
                                                            </label>
                                                            <Creatable
                                                                classNames={{
                                                                    control: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'flex items-center w-full min-w-[200px] !bg-black-5  border border-black-10 !hover:border-black-20 !rounded-none !shadow-none',
                                                                            state.isFocused &&
                                                                                '!border-green-dark',
                                                                        ),
                                                                    option: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            state.isSelected &&
                                                                                'bg-green-primary text-white',
                                                                            'hover:bg-green-primary hover:text-white over:text-white',
                                                                        ),
                                                                    menu: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'shadow-swegon2 border border-black-20 !z-50',
                                                                        ),
                                                                    menuPortal:
                                                                        (
                                                                            state,
                                                                        ) =>
                                                                            '!z-50',
                                                                }}
                                                                menuPortalTarget={
                                                                    document.body
                                                                }
                                                                components={{
                                                                    DropdownIndicator:
                                                                        null,
                                                                }}
                                                                hideSelectedOptions
                                                                options={equipmentList.map(
                                                                    (
                                                                        value,
                                                                    ) => ({
                                                                        value,
                                                                        label: value,
                                                                    }),
                                                                )}
                                                                onChange={(
                                                                    selectedOption,
                                                                ) => {
                                                                    formik.setFieldValue(
                                                                        `tags[${idx}].equipmentType`,
                                                                        selectedOption
                                                                            ? selectedOption.value
                                                                            : '',
                                                                    );
                                                                }}
                                                                onBlur={(
                                                                    event,
                                                                ) => {
                                                                    const inputValue =
                                                                        event
                                                                            .target
                                                                            .value;
                                                                    if (
                                                                        inputValue.trim() !==
                                                                        ''
                                                                    ) {
                                                                        formik.setFieldValue(
                                                                            `tags[${idx}].equipmentType`,
                                                                            inputValue,
                                                                        );
                                                                    }
                                                                }}
                                                                value={{
                                                                    value: row.equipmentType,
                                                                    label: row.equipmentType,
                                                                }}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags[${idx}].room`}
                                                            >
                                                                Room
                                                            </label>
                                                            <Creatable
                                                                classNames={{
                                                                    control: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'flex items-center w-full min-w-[200px] !bg-black-5  border border-black-10 !hover:border-black-20 !rounded-none !shadow-none',
                                                                            state.isFocused &&
                                                                                '!border-green-dark',
                                                                        ),
                                                                    option: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            state.isSelected &&
                                                                                'bg-green-primary text-white',
                                                                            'hover:bg-green-primary hover:text-white over:text-white',
                                                                        ),
                                                                    menu: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'shadow-swegon2 border border-black-20 !z-50',
                                                                        ),
                                                                    menuPortal:
                                                                        (
                                                                            state,
                                                                        ) =>
                                                                            '!z-50',
                                                                }}
                                                                menuPortalTarget={
                                                                    document.body
                                                                }
                                                                components={{
                                                                    DropdownIndicator:
                                                                        null,
                                                                }}
                                                                hideSelectedOptions
                                                                options={[
                                                                    ...new Set(
                                                                        (
                                                                            tags ||
                                                                            []
                                                                        )
                                                                            .map(
                                                                                (
                                                                                    t,
                                                                                ) =>
                                                                                    t.room,
                                                                            )
                                                                            .filter(
                                                                                Boolean,
                                                                            )
                                                                            .sort(),
                                                                    ),
                                                                ].map(
                                                                    (
                                                                        value,
                                                                    ) => ({
                                                                        value,
                                                                        label: value,
                                                                    }),
                                                                )}
                                                                onChange={(
                                                                    selectedOption,
                                                                ) => {
                                                                    formik.setFieldValue(
                                                                        `tags[${idx}].room`,
                                                                        selectedOption
                                                                            ? selectedOption.value
                                                                            : '',
                                                                    );
                                                                }}
                                                                onBlur={(
                                                                    event,
                                                                ) => {
                                                                    const inputValue =
                                                                        event
                                                                            .target
                                                                            .value;
                                                                    if (
                                                                        inputValue.trim() !==
                                                                        ''
                                                                    ) {
                                                                        formik.setFieldValue(
                                                                            `tags[${idx}].room`,
                                                                            inputValue,
                                                                        );
                                                                    }
                                                                }}
                                                                value={{
                                                                    value: row.room,
                                                                    label: row.room,
                                                                }}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags[${idx}].trade`}
                                                            >
                                                                Trade
                                                            </label>
                                                            <Creatable
                                                                classNames={{
                                                                    control: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'flex items-center w-full min-w-[200px] !bg-black-5  border border-black-10 !hover:border-black-20 !rounded-none !shadow-none',
                                                                            state.isFocused &&
                                                                                '!border-green-dark',
                                                                        ),
                                                                    option: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            state.isSelected &&
                                                                                'bg-green-primary text-white',
                                                                            'hover:bg-green-primary hover:text-white over:text-white',
                                                                        ),
                                                                    menu: (
                                                                        state,
                                                                    ) =>
                                                                        classNames(
                                                                            'shadow-swegon2 border border-black-20 !z-50',
                                                                        ),
                                                                    menuPortal:
                                                                        (
                                                                            state,
                                                                        ) =>
                                                                            '!z-50',
                                                                }}
                                                                menuPortalTarget={
                                                                    document.body
                                                                }
                                                                components={{
                                                                    DropdownIndicator:
                                                                        null,
                                                                }}
                                                                hideSelectedOptions
                                                                options={tradeList.map(
                                                                    (
                                                                        value,
                                                                    ) => ({
                                                                        value,
                                                                        label: value,
                                                                    }),
                                                                )}
                                                                onChange={(
                                                                    selectedOption,
                                                                ) => {
                                                                    formik.setFieldValue(
                                                                        `tags[${idx}].trade`,
                                                                        selectedOption
                                                                            ? selectedOption.value
                                                                            : '',
                                                                    );
                                                                }}
                                                                onBlur={(
                                                                    event,
                                                                ) => {
                                                                    const inputValue =
                                                                        event
                                                                            .target
                                                                            .value;
                                                                    if (
                                                                        inputValue.trim() !==
                                                                        ''
                                                                    ) {
                                                                        formik.setFieldValue(
                                                                            `tags[${idx}].trade`,
                                                                            inputValue,
                                                                        );
                                                                    }
                                                                }}
                                                                value={{
                                                                    value: row.trade,
                                                                    label: row.trade,
                                                                }}
                                                            />
                                                        </div>

                                                        <div>
                                                            <label
                                                                className={classNames(
                                                                    'block mb-2 text-sm font-medium',
                                                                    {
                                                                        hidden:
                                                                            idx !==
                                                                            0,
                                                                    },
                                                                )}
                                                                htmlFor={`tags[${idx}].quantity`}
                                                            >
                                                                Quantity
                                                            </label>
                                                            <div className="swegon-ui-quantity-input-wrapper h-[38px]">
                                                                <input
                                                                    type="number"
                                                                    min={1}
                                                                    id={`tags[${idx}].quantity`}
                                                                    name={`tags[${idx}].quantity`}
                                                                    value={
                                                                        row.quantity ??
                                                                        ''
                                                                    }
                                                                    className="flex items-center w-full min-w-[80px] !bg-black-5 border border-black-10 !hover:border-black-20 !rounded-none !shadow-none h-8 px-3"
                                                                    onChange={(
                                                                        e,
                                                                    ) => {
                                                                        const input =
                                                                            e
                                                                                .target
                                                                                .value;
                                                                        if (
                                                                            input ===
                                                                            ''
                                                                        ) {
                                                                            formik.setFieldValue(
                                                                                `tags[${idx}].quantity`,
                                                                                '',
                                                                            );
                                                                            return;
                                                                        }
                                                                        const val =
                                                                            parseInt(
                                                                                input,
                                                                                10,
                                                                            );
                                                                        formik.setFieldValue(
                                                                            `tags[${idx}].quantity`,
                                                                            isNaN(
                                                                                val,
                                                                            )
                                                                                ? ''
                                                                                : val,
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ),
                                            )}

                                            <div>
                                                <button
                                                    className="swegon-like-button outlined"
                                                    type="button"
                                                    onClick={() =>
                                                        tagsHelpers.push(
                                                            defaultTagValues,
                                                        )
                                                    }
                                                >
                                                    Add tag
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </FieldArray>

                                <div className="flex justify-end">
                                    <button
                                        onClick={onClose}
                                        type="button"
                                        className="swegon-like-button outlined mr-4 !px-4 amber"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="swegon-like-button contained"
                                        type="submit"
                                        disabled={formik.isSubmitting}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    );
};
